import React from 'react'
import "./InputComponent.scss"
import PhoneInput from 'react-phone-number-input'

const PhoneInpuComponent = ({ placeholder, value, onChange, layout = "layout1", type = "text", isError = false, errorMessage = "", disabled, required = false }) => {


    return (
        <div className='InputComponent-Wrapper'>
            <div className={`InputComponent-${layout}  ${isError ? "InputComponent-error" : ""} ${disabled ? "InputComponent-disabled" : ""}`}>
                <PhoneInput
                    defaultCountry="GB"
                    placeholder={`${placeholder || ""}${required ? "*" : ""}`}
                    value={value}
                    onChange={onChange}
                    disabled={disabled ?? false}

                />
            </div>
            {isError && <div className='InputComponent-error'>{errorMessage}</div>}
        </div>

    )
}
export default PhoneInpuComponent